export function datetimeStrToEpoch(datetimeStr: string): number {
  let date = new Date(datetimeStr);

  if (isNaN(date.getTime())) {
    console.warn(
      `Failed to parse datetime string: ${datetimeStr}, returning epoch date`,
    );
    return 0; // Return epoch date for invalid datetime strings
  }

  return date.getTime();
}
